export const copyButton = (function ($) {
    function init() {
        $('.js-copy-button').click(function() {
            const textToCopy = $(this).prev().text();
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    $(this).addClass('success');
                    console.log(`Copied "${textToCopy}" to clipboard`);

                    setTimeout(() => {
                        $(this).removeClass('success');
                    }, 2000)
                })
                .catch((err) => {
                    $(this).addClass('error');
                    console.error('Could not copy text: ', err);

                    setTimeout(() => {
                        $(this).removeClass('error');
                    }, 2000)
                });
        });
    }

    return {
        init: init,
    };
})(jQuery);
